module.exports = __webpack_public_path__ + "media/images/pattern2-a7402036fb507cd1ea7f0664619338b9.png";